/**
 * Numbering follows the boxes on the ICS 205A-CG form, as printed by
 * `services/coms/src/routes/Forms/ICS_CG/forms/ICS205ACG.ts`.
 *
 * Boxes 1 to 3 are the read-only header, box 4 is the contact table whose
 * columns are listed separately below, and box 5 is the signature.
 */
export const ICS205A_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  operationalPeriod: '3. Operational Period (Date/Time):',
  contacts: '4. Basic Local Communications Information:',
  preparedBy: '5. Prepared by (Communications Unit Leader):',
} as const;

/**
 * What each printed column of box 4 holds.
 *
 * The last three sit under a shared "Methods of Contact" rule on the paper,
 * which `group` records so the table can print the same spanning header.
 */
export const ICS205A_PRINTED_COLUMNS = [
  { label: 'Assignment', source: 'assignment' },
  { label: 'Name', source: 'name' },
  { label: 'Cell Phone #', source: 'cell_phone', group: 'Methods of Contact' },
  {
    label: 'Radio Frequency',
    source: 'radio_frequency',
    group: 'Methods of Contact',
  },
  { label: 'Other', source: 'other', group: 'Methods of Contact' },
] as const;

export const ICS205A_INCIDENT_NAME_HINT =
  'This box is read-only. It is filled from the incident name.';

export const ICS205A_INCIDENT_LOCATION_HINT =
  'This box is read-only. It is filled from the incident location, falling back to the address set when the incident was created.';

export const ICS205A_OPERATIONAL_PERIOD_HINT =
  'Click this box to set the scheduled start and end of the next operational period for this incident workspace. Working-period forms print that window.';

/**
 * Contacts are incident-scoped rather than period-scoped, matching the 205's
 * channels, so the same rows print on every period's 205A.
 */
export const ICS205A_CONTACTS_HINT =
  'Contacts belong to the incident, not to one operational period. Fill From Roster adds a row per assigned responder, skipping anyone already listed.';
